import { useInvoiceAddressCollectionData } from '../invoice-address-collection/InvoiceAddressCollectionDataConsumer';
import { useWarehouseAddressCollectionData } from '../warehouse-address-collection/WarehouseAddressCollectionDataConsumer';

export const useAddressCollectionData = () => ({
    invoiceAddressCollectionData: useInvoiceAddressCollectionData(),
    warehouseAddressCollectionData: useWarehouseAddressCollectionData(),
});
